import { render } from "./IPInfo.vue?vue&type=template&id=20dd49c0&scoped=true&lang=pug"
import script from "./IPInfo.vue?vue&type=script&lang=js"
export * from "./IPInfo.vue?vue&type=script&lang=js"

import "./IPInfo.vue?vue&type=style&index=0&id=20dd49c0&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dd49c0"]])

export default __exports__